<template>
  <div>
    <button class="lg:hidden details__title" type="button" @click="openDrawer">
      <span class="text-left flex-grow">Ficha técnica</span>
      <i class="fas fa-chevron-right flex-none"></i>
    </button>

    <div class="hidden lg:block">
      <h6 class="details__title">Ficha técnica</h6>
      <slot />
    </div>

    <drawer-datasheet ref="drawer">
      <slot />
    </drawer-datasheet>
  </div>
</template>

<script>
import DrawerDatasheet from './DrawerDatasheet'

export default {
  components: {
    DrawerDatasheet
  },

  methods: {
    openDrawer() {
      this.$refs.drawer.open()
    }
  }
}
</script>

<style lang="scss" scoped>
button.details__title {
  @apply w-full;
  @apply flex;

  &:active, &:focus {
    outline: none;
  }
}
</style>
